import { getRecentlyViewed, saveRecentlyViewed } from 'utils/recently-viewed-cache';

const SECTION = 'product-recently-viewed-card';

const getProductId = (): string | null => {
  try {
    const el = document.querySelector('[data-component="product"] [data-data]');
    if (!el) return null;
    const data = JSON.parse(el.textContent ?? '');
    return String(data.id);
  } catch {
    return null;
  }
};

const track = async (): Promise<void> => {
  if (theme.pageType !== 'product') return;

  const productId = getProductId();
  if (!productId) return;

  const existing = getRecentlyViewed();
  const cached = existing.find((e) => e.productId === productId);

  if (cached) {
    saveRecentlyViewed(productId, cached.html);
    return;
  }

  try {
    const res = await fetch(`${window.location.pathname}?sections=${SECTION}`);
    if (!res.ok) return;

    const json = (await res.json()) as Record<string, string>;
    const raw = json[SECTION];
    if (!raw) return;

    const wrapper = document.createElement('div');
    wrapper.innerHTML = raw;

    const inner = wrapper.querySelector(`#shopify-section-${SECTION}`);
    saveRecentlyViewed(productId, (inner?.innerHTML ?? raw).trim());
  } catch {}
};

track();
